import { axiosInstance } from "../utils/axios";
import { getAuthHeader } from "../utils/authTools";

export const createConversation = async (conversationData) => {
    try {
        const response = await axiosInstance.post(
            "/conversation/create",
            conversationData,
            getAuthHeader()
        );
        return response.data;
    } catch (error) {
        throw new Error("Error creating conversation");
    }
};

export const updateConversation = async (conversationId, conversationData) => {
    try {
        const response = await axiosInstance.patch(
            `/conversation/update/${conversationId}`,
            conversationData,
            getAuthHeader()
        );
        return response.data;
    } catch (error) {
        throw new Error("Error updating conversation");
    }
};

export const fetchConversation = async (conversationId) => {

    try {
        const response = await axiosInstance.get(
            `/conversation/${conversationId}`,
            getAuthHeader()
        );
        return response.data;
    } catch (error) {
        throw new Error("Error deleting conversation");
    }
};

export const getConversation = async () => {
    try {
        const response = await axiosInstance.get(
            `/conversation`,
            getAuthHeader()
        );
        return response.data;
    } catch (error) {
        throw new Error("Error fetching conversation");
    }
};

export const deleteConversation = async (conversationId) => {

    try {
        const response = await axiosInstance.delete(
            `/conversation/delete/${conversationId}`,
            getAuthHeader()
        );
        return response.data;
    } catch (error) {
        throw new Error("Error deleting conversation");
    }
};

export const clearConversation = async () => {

    try {
        const response = await axiosInstance.delete(
            `/conversation/clearConversation/`,
            getAuthHeader()
        );
        return response.data;
    } catch (error) {
        throw new Error("Error deleting conversation");
    }
};